import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { cn } from '@/lib/utils';

export interface GlobalDisableConfirmProps {
  /** Display name shown in the dialog title, e.g. "All Discovery Plugins" or a plugin name */
  pluginName: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isPending: boolean;
}

export function GlobalDisableConfirm({
  pluginName,
  open,
  onOpenChange,
  onConfirm,
  isPending,
}: GlobalDisableConfirmProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Disable {pluginName}?</AlertDialogTitle>
          <AlertDialogDescription>
            This will immediately disable {pluginName} for{' '}
            <span className="text-chariot-text-primary font-semibold">
              all accounts
            </span>
            . Active discovery scans will not be interrupted, but no new scans
            will be queued until discovery is re-enabled.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isPending}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isPending}
            className={cn(
              'bg-destructive text-destructive-foreground hover:bg-destructive/90'
            )}
          >
            {isPending ? 'Disabling...' : 'Disable'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
